import React from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Field } from 'formik'
import { Form, Button } from 'lib/ui/components'
import { Wrapper } from './styled'
import { useBlogContext } from 'hooks/blog'

export const Toolbar: React.FC = () => {
  const history = useHistory()
  const { isSearchPage } = useBlogContext()

  const handleSearch = (value: Record<string, string>) => {
    history.replace(`/blog/search/${value.search}`)
  }

  const initialValues = {
    search: ''
  }

  return (
    <Wrapper>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSearch}
      >
        <Form.Wrapper>
          <label>Search the knowledge base</label>
          <div className='field'>
            <Field
              name='search'
              component={Form.Input}
            />
            <Button type='submit'>
              Search
            </Button>
          </div>
        </Form.Wrapper>
      </Formik>
      {isSearchPage && (
        <Button onClick={() => history.push('/blog')}>
          Back to Blog {'>'}
        </Button>
      )}
    </Wrapper>
  )
}
